import Vue from 'vue';

export default new Vue({
    data:{
        anchor: null,
        scrolledAnchor: null
    }
});





// WEBPACK FOOTER //
// ./src/public_app/api/shared.js